import React from "react";

export default function Header() {
  return (
    <header className="lead-txt">
      <h1>React Props Working Example</h1>
      <p>
        This is a simple react props example. You can see the code
        <a href="https://github.com/bhantsi/react-props"> on GitHub</a>.
      </p>
    </header>
  );
}


// WEBPACK FOOTER //
// ./src/components/Header.js